export const BUYERS_OPTIONS = [
  {
    label: 'Autohuissalland verkoper',
    value: 1,
  }
];
